import React from 'react';
import { Card, CardContent } from './ui/Card';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  company: string;
  image: string;
}
export function TestimonialCard({
  quote,
  author,
  role,
  company,
  image
}: TestimonialCardProps) {
  return <Card className="h-full border-0 shadow-lg ring-1 ring-gray-900/5 bg-gray-50" data-id="element-195">
      <CardContent className="p-8" data-id="element-196">
        <Quote className="h-8 w-8 text-primary/20 mb-6" data-id="element-197" />
        <blockquote className="text-lg font-medium text-gray-900 mb-6" data-id="element-198">
          "{quote}"
        </blockquote>
        <div className="flex items-center" data-id="element-199">
          <img className="h-12 w-12 rounded-full object-cover ring-2 ring-white" src={image} alt={author} data-id="element-200" />
          <div className="ml-4" data-id="element-201">
            <div className="text-base font-semibold text-gray-900" data-id="element-202">
              {author}
            </div>
            <div className="text-sm text-gray-600" data-id="element-203">
              {role}, {company}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>;
}